import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { FaDownload, FaCalendarAlt, FaStar, FaArrowLeft } from "react-icons/fa";
import Confetti from "react-confetti";
import useWindowSize from "../landingPage/achievements/UseWindowSize";
import { Link } from "react-router-dom";

const ResumeShowcase = () => {
  const [showConfetti, setShowConfetti] = useState(false);
  const { width, height } = useWindowSize();

  useEffect(() => {
    // Safely load Cal.com script for popup modal
    try {
      window.Cal =
        window.Cal ||
        function () {
          (window.Cal.q = window.Cal.q || []).push(arguments);
        };

      let script = document.querySelector(
        'script[src="https://app.cal.com/embed/embed.js"]',
      );
      if (!script) {
        script = document.createElement("script");
        script.src = "https://app.cal.com/embed/embed.js";
        script.async = true;
        script.onerror = () => {};
        document.head.appendChild(script);
      }

      if (window.Cal) {
        window.Cal("init", { origin: "https://cal.com" });
      }
    } catch (e) {
      // Ignore initial script errors
    }
  }, []);

  const triggerDownload = () => {
    setShowConfetti(true);
    setTimeout(() => setShowConfetti(false), 5000);
  };

  return (
    <div className="w-full min-h-screen bg-slate-50 text-slate-900 py-12 px-4 relative">
      {/* Confetti Explosion Layer */}
      {showConfetti && (
        <Confetti
          width={width || 1200}
          height={height || 800}
          numberOfPieces={300}
          recycle={false}
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            zIndex: 9999,
            pointerEvents: "none",
          }}
        />
      )}

      <div className="max-w-4xl mx-auto space-y-8">
        {/* Back Navigation Bar */}
        <div className="flex items-center justify-between">
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-xs font-bold font-mono text-slate-700 hover:text-slate-900 border border-slate-300 px-3.5 py-2 rounded-xl transition shadow-sm"
          >
            <FaArrowLeft />
            <span>Back to Portfolio</span>
          </Link>
        </div>

        {/* High Impact Header */}
        <div className="text-center space-y-3">
          <h2 className="text-slate-600 text-xl lg:text-3xl max-w-2xl mx-auto font-medium">
            I turn “wouldn't it be cool if…” into “it's live.”
          </h2>

          {/* Highlights Strip */}
        </div>

        {/* Recruiter Action Bar */}
        <div className="flex flex-wrap gap-3 justify-center items-center p-3 rounded-2xl shadow-sm">
          {/* Download Resume Button */}
          <motion.a
            href="/resume.pdf"
            download
            onClick={triggerDownload}
            className="bg-slate-900 hover:bg-slate-800 text-white text-xs font-bold py-2.5 px-5 rounded-xl shadow transition-all duration-300 flex items-center gap-2 border border-slate-900"
            whileTap={{ scale: 0.95 }}
          >
            <FaDownload className="text-xs" />
            <span>Download Resume (PDF)</span>
            <FaStar className="text-amber-400 text-xs animate-spin" />
          </motion.a>

          {/* Cal.com Booking Modal Button */}
          <a
            href="https://cal.com/bharat-pahwa/30min"
            target="_blank"
            rel="noopener noreferrer"
            data-cal-link="bharat-pahwa/30min"
            data-cal-config='{"layout":"month_view"}'
            className="bg-gradient-to-r from-violet-600 to-indigo-600 hover:from-violet-700 hover:to-indigo-700 text-white text-xs font-bold py-2.5 px-4 rounded-xl transition-all duration-300 flex items-center gap-2 cursor-pointer shadow-sm"
          >
            <FaCalendarAlt className="text-xs" />
            <span>Book 1:1 Call</span>
          </a>
        </div>

        {/* Clean Frameless PDF Preview Container */}
        <div className="w-full h-[650px] md:h-[750px] lg:h-[850px] bg-white rounded-2xl border border-slate-300 overflow-hidden shadow-sm">
          <iframe
            src="/resume.pdf"
            className="w-full h-full"
            style={{ border: 0 }}
            title="Resume Preview"
          />
        </div>
      </div>
    </div>
  );
};

export default ResumeShowcase;
